import React from "react";
import PropTypes from "prop-types";
import ConstrainedSelect from "./ConstrainedSelect";
import { getMessage } from "../data/locales";

function StudentTrackingFilters({
  query,
  topicKey,
  topicOptions,
  evaluatedContents,
  unevaluatedContents,
  canClear,
  onQueryChange,
  onTopicChange,
  onEvaluatedContentsChange,
  onUnevaluatedContentsChange,
  onClear,
}) {
  return (
    <section className="pa-filters" aria-label={getMessage("studentTracking.filtersTitle")}>
      <h3 className="pa-filters-title">{getMessage("studentTracking.filtersTitle")}</h3>
      <div className="pa-filters-grid">
        <label className="pa-label pa-filter-field" htmlFor="pa-student-search">
          <span>{getMessage("studentTracking.filterStudent")}</span>
          <input
            id="pa-student-search"
            className="pa-filter-input"
            type="search"
            value={query}
            onChange={(event) => onQueryChange(event.target.value)}
            placeholder={getMessage("studentTracking.filterStudentPlaceholder")}
            autoComplete="off"
          />
        </label>
        <label className="pa-label pa-filter-field" htmlFor="pa-topic-filter">
          <span>{getMessage("studentTracking.filterTopic")}</span>
          <ConstrainedSelect
            id="pa-topic-filter"
            className="pa-select pa-filter-select"
            value={topicKey}
            ariaLabel={getMessage("studentTracking.filterTopic")}
            onChange={onTopicChange}
            options={[
              { value: "", label: getMessage("studentTracking.filterTopicAll") },
              ...topicOptions,
            ]}
          />
        </label>
        <fieldset className="pa-filter-checks">
          <legend>{getMessage("studentTracking.filterContentsLegend")}</legend>
          <label className="pa-filter-check" htmlFor="pa-filter-evaluated">
            <input
              id="pa-filter-evaluated"
              type="checkbox"
              checked={evaluatedContents}
              onChange={(event) => onEvaluatedContentsChange(event.target.checked)}
            />
            <span>{getMessage("studentTracking.filterEvaluatedContents")}</span>
          </label>
          <label className="pa-filter-check" htmlFor="pa-filter-unevaluated">
            <input
              id="pa-filter-unevaluated"
              type="checkbox"
              checked={unevaluatedContents}
              onChange={(event) => onUnevaluatedContentsChange(event.target.checked)}
            />
            <span>{getMessage("studentTracking.filterUnevaluatedContents")}</span>
          </label>
        </fieldset>
        <div className="pa-filter-actions">
          <button
            type="button"
            className="pa-filter-clear"
            onClick={onClear}
            disabled={!canClear}
          >
            {getMessage("studentTracking.clearFilters")}
          </button>
        </div>
      </div>
    </section>
  );
}

export default StudentTrackingFilters;

StudentTrackingFilters.propTypes = {
  query: PropTypes.string.isRequired,
  topicKey: PropTypes.string.isRequired,
  topicOptions: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  }).isRequired).isRequired,
  evaluatedContents: PropTypes.bool.isRequired,
  unevaluatedContents: PropTypes.bool.isRequired,
  canClear: PropTypes.bool.isRequired,
  onQueryChange: PropTypes.func.isRequired,
  onTopicChange: PropTypes.func.isRequired,
  onEvaluatedContentsChange: PropTypes.func.isRequired,
  onUnevaluatedContentsChange: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
};
